import React from "react";
import {interpolate, useCurrentFrame} from "remotion";
import {techLaunchData} from "../../../data/techLaunchData";


export const Feature: React.FC = () => {

  const frame = useCurrentFrame();


  const opacity = interpolate(
    frame,
    [0, 30],
    [0, 1],
    {
      extrapolateRight: "clamp",
    }
  );


  const translateY = interpolate(
    frame,
    [0, 60],
    [80, 0],
    {
      extrapolateRight: "clamp",
    }
  );


  return (

    <div
      style={{
        flex: 1,
        backgroundColor: "#101010",
        color: "white",
        padding: 80,
        opacity,
        transform: `translateY(${translateY}px)`,
      }}
    >

      <h1
        style={{
          fontSize: 70,
          marginBottom: 60,
        }}
      >
        核心能力
      </h1>


      {
        techLaunchData.features.map(
          (item, index) => (

            <div
              key={index}
              style={{
                fontSize: 45,
                marginBottom: 30,
                padding: 20,
                borderRadius: 20,
                backgroundColor: "#222",
              }}
            >

              {item}

            </div>

          )
        )
      }


    </div>

  );
};
